import { z } from 'zod';
export const allowedAssetMimeTypeSchema = z.enum([
    'image/png',
    'image/jpeg',
    'image/webp',
    'text/plain',
]);
export const assetOwnerKindSchema = z.enum(['parent', 'child']);
export const MAX_ASSET_SIZE_BYTES = 5 * 1024 * 1024; // 5 MiB
export const storedAssetSchema = z.object({
    id: z.string(),
    ownerKind: assetOwnerKindSchema,
    ownerId: z.string(),
    key: z.string(),
    mimeType: allowedAssetMimeTypeSchema,
    sizeBytes: z.number().int().min(0).max(MAX_ASSET_SIZE_BYTES),
    createdAt: z.string().datetime(),
});
export const createUploadUrlRequestSchema = z.object({
    ownerKind: assetOwnerKindSchema,
    ownerId: z.string(),
    mimeType: allowedAssetMimeTypeSchema,
    sizeBytes: z.number().int().min(1).max(MAX_ASSET_SIZE_BYTES),
    fileName: z.string().min(1).max(200),
});
export const createUploadUrlResponseSchema = z.object({
    assetId: z.string(),
    uploadUrl: z.string().url(),
    method: z.enum(['PUT', 'POST']),
    headers: z.record(z.string(), z.string()).optional(),
    expiresAt: z.string().datetime(),
});
export const completeUploadRequestSchema = z.object({
    assetId: z.string(),
});
export const completeUploadResponseSchema = z.object({
    asset: storedAssetSchema,
});
export const readUrlResponseSchema = z.object({
    readUrl: z.string().url(),
    expiresAt: z.string().datetime(),
});
//# sourceMappingURL=asset.js.map